<template>
  <el-container class="home_container" >
    <el-main :style="elmainStyle">
      <div
            style="background-color: #fff; color:red;text-align: center;height:30px; border-radius:4px;margin-left: 16px;margin-top: 16px;"
            v-if="isNoticeShow && EnterpriseNotices.length != 0"
          >
            <MyMarquee :lists="EnterpriseNotices" />
      </div>
      <el-row
        v-for="(grid, i) in gridList"
        :key="i"
        :gutter="grid.options.gutter"
      >
        <!-- <div v-if="i==1">
          <div
            style="background-color: #fff; color:red;text-align: center;height:30px; border-radius:4px"
            v-if="isNoticeShow && EnterpriseNotices.length != 0"
          >
            <MyMarquee :lists="EnterpriseNotices" />
          </div>
        </div> -->
        <div v-if="grid.type == 'grid'" class="news-wrap">
          <el-col
            v-for="(columns, j) in grid.columns"
            :Key="j"
            :span="columns.span"
          >
            <ht-column
              v-for="(cl, k) in columns.list"
              :key="k"
              :column-alias="cl.alias"
            ></ht-column>
          </el-col>
        </div>
        <div v-if="!grid.type">
          <el-col :span="24">
            <ht-column :column-alias="grid.alias"></ht-column>
          </el-col>
        </div>
      </el-row>
    </el-main>

    <div
      class="tip__message"
      v-if="isShowTip && (messageList.length > 0 || supervisorNoticeList.length > 0)"
      :class="{ only__title: !isUp }"
    >
      <div class="tip__message-topwrap">
        <span class="tip__message-title"><img src="/fvue/img/message.png">提示信息
          <span style="font-size: 14px;padding-left: 8px;">{{messageList.length}}条</span>
        </span>
        <div class="icon__wrap">
          <i
            class="el-icon-arrow-up icon__wrap-item"
            :class="[isUp ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
            @click="isUp = !isUp"
          ></i>
          <i class="el-icon-close icon__wrap-item" @click="hideTip"></i>
        </div>
      </div>
      <div style="overflow: auto; height:232px;">
        <ul class="tip__message-ul" v-show="isUp" v-loading="tipLoading">
          <li
            class="tip__message-item"
            v-for="(tip, index) in messageList"
            :key="index"
            @click="goToTargetPage(tip)"
          >
            <img src="/fvue/img/message-item.png" style="padding-right: 4px;">{{ tip.desc }}
          </li>
        </ul>
      </div>
     
    </div>
    <el-dialog
      :title="tipTitle"
      :visible.sync="dialogTipVisible"
      :width="dialogWidth"
      custom-class="tip-dialog"
      top="8vh"
      ref="tipDialog"
      :before-close="handleClose"
    >
      <div class="iframe-wrap">
        <iframe
          style="width:100%;margin:0px;"
          frameborder="0"
          class="fullheight"
          allowtransparency="0"
          :src="srcUrl"
        ></iframe>
      </div>
    </el-dialog>
    <div v-show="Hood" class="Hood">
      <p style="text-align: right;
        position: absolute;
        top: 137px;
        right: 50px;
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        z-index: 1002;
        color: #FFFFFF;cursor:pointer;" @click="closeHood">关闭</p>
      <div class="HoodBackground">
        <div style="pointer-events:none;">
          <div class="carouselIndex">
            <el-carousel :height="HoodHeight" :style="HoodStyle" arrow="never" indicator-position="none">
              <el-carousel-item v-for="(item, index) in HolidayTips" :key="index">
                <div v-if="item.tcwb" style="text-align: center;">
                  <img :src="item.bjtp" class="HoodImg" :style="imageStyleBack" title="加载中..." alt="加载中...">
                  <div style="width:100%;height:20%;">
                    <span class="haiyaText" v-html="item.tcwb"></span>
                  </div>
                </div>
                <div v-else>
                  <img :src="item.bjtp" class="HoodImg" :style="imageStyle" title="加载中..." alt="加载中...">
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>

  </el-container>
</template>
<script>
let Base64 = require("js-base64").Base64;
import HtColumn from "@/components/common/HtColumn.vue";
import MyMarquee from "../components/common/MyMarquee";
import { mapState } from "vuex";
import introJs from 'intro.js' // introjs库
import 'intro.js/introjs.css' // introjs默认css样式
import 'intro.js/themes/introjs-modern.css' // introjs主题

import req from "@/request.js";
export default {
  components: { HtColumn, MyMarquee },
  data() {
    return {
      dialogWidth: null,
      dialogTipVisible: false,
      tipTitle: "",
      srcUrl: "",
      isShowTip: true,
      isUp: true,
      tipLoading: false,
      messageList: [],
      layout: {},
      gridList: [],
      EnterpriseNotices: [], //企业公告
      isNoticeShow: false,
      notifyList: [],
      supervisorNoticeList: [],
      elmainStyle:{height:window.innerHeight * 0.93 + "px"},
      Hood:false,
      HolidayTips:[],
      TimeOut:10,
      HoodHeight:window.innerHeight+'px',
      HoodStyle:{'width':window.innerWidth+'px'},
      imageStyle:{'width':window.innerWidth+'px','height':window.innerHeight+'px'},
      imageStyleBack:{'width':window.innerWidth +'px','height':window.innerHeight*0.9+'px'},
    };
  },
  computed: mapState({
    menus: state => state.menu.all
  }),
  created() {
     window.jQuery("#app").find("[name='app-base-main']").css("overflow-y","hidden");
    this.notifyList = [];
    const me_ = this;
    let i = 0;
    this.$store.dispatch("form/getFormRemindDataByUser").then((data) => {
      this.supervisorNoticeList = data;
      console.log(data);
      data.forEach((item) => {
        setTimeout(() => {
          // me_.dialogMessage(item);
        }, i);
        i = i + 500;
      });
    });
    this.$store.dispatch("menu/vueFrontHome").then((data) => {
      this.layout = JSON.parse(Base64.decode(data.value) || "{}");
      if (this.layout && this.layout.list && this.layout.list.length > 0) {
        this.gridList = this.layout.list;
      }
    });
    this.getTipMessageData();
  },
  mounted() {
    // this.$refs.carousel.handleMouseEnter = () => {};
    console.log("this.$refs.carousel:"+this.$refs.carousel);
    window.jQuery(".home_container").find(".el-main").css("height",window.innerHeight-48+"px");
    let this_ = this;
    let User = JSON.parse(window.sessionStorage.currentUser);
    req.post(window.context.portal+"/bpm/haiyaapi/getHolidayTips").then((resp) => {debugger;//获取节假日列表
        if(resp.data != null){//有弹窗数据
          for(let i=0;i<resp.data.length;i++){
            let pojo = JSON.parse(resp.data[i].bjtp);
            let url = window.context.portal + "/system/file/v1/downloadFile?fileId=";
            if((resp.data[i].lx=='员工生日' || resp.data[i].lx=='入职周年')){//需要绑定登录用户
              if(User.account==resp.data[i].account){
                this_.HolidayTips.push({tcwb:resp.data[i].tcwb,bjtp:url+pojo[0].id});
                if(sessionStorage.HolidayTips=='true' || sessionStorage.HolidayTips==true){//打开节假日弹窗图片
                  this_.Hood = true;
                  sessionStorage.HolidayTips=false;//不允许弹出节假日
                }
              }
            }else{//全员通用
              this_.HolidayTips.push({tcwb:resp.data[i].tcwb,bjtp:url+pojo[0].id});
              if(sessionStorage.HolidayTips=='true' || sessionStorage.HolidayTips==true){//打开节假日弹窗图片
                this_.Hood = true;
                sessionStorage.HolidayTips=false;//不允许弹出节假日
              }
            }
          }
        }
    });

    this_.getEnterpriseNotice();





    // let timers = setInterval(function(){//倒计时关闭页面
    //   if(this_.TimeOut > 0 && (sessionStorage.HolidayTips=='true' || sessionStorage.HolidayTips==true)){//允许弹出节假日
    //     this_.Hood = true;
    //     this_.TimeOut = this_.TimeOut-1;
    //     if(this_.TimeOut==0 || this_.TimeOut=='0'){
    //       sessionStorage.HolidayTips=false;//不允许弹出节假日
    //       this_.closeHood();//自动关闭节假日弹窗
    //       window.clearInterval(timers);
    //     }
    //   }else{
    //     this_.closeHood();//自动关闭节假日弹窗
    //     window.clearInterval(timers);
    //   }
    // },1000)
  },
  methods: {
  //访问引导页
  guide() {
      let User = JSON.parse(window.sessionStorage.currentUser);
      introJs().setOptions({
        prevLabel: "上一步",
        nextLabel: "下一步",
        skipLabel: "x",
        doneLabel: "结束",
        disableInteraction:true,//是否禁止交互
        hidePrev:true,// 隐藏第一步中的上一个按钮
        exitOnOverlayClick: false,//是否允许点击空白处退出
        exitOnEsc: false,//是否使用键盘Esc退出
        showStepNumbers:false,//是否显示说明的数据步骤
        showBullets: true,//是否使用点点点显示进度
        scrollToElement:true,//是否滑动到高亮的区域
        showProgress:false,//是否显示进度条
        tooltipClass: '',//引导说明文本框的样式 
        highlightClass:'',//说明高亮区域的样式
      }).oncomplete(function () {
          //点击结束按钮后， 执行的事件
          if(sessionStorage.guide=='true' || sessionStorage.guide==true){
            sessionStorage.guide=false;//本次登录会话内不再提示
            req.post(window.context.portal +"/bpm/haiyaapi/updateManageGuide?account="+User.account).then((response) => {
              // window.app.$alert("您已完成本次系统操作指引。", '提示');
            });
          }
      }).onexit(function () {
          //点击结束按钮后， 执行的事件
          if(sessionStorage.guide=='true' || sessionStorage.guide==true){
            sessionStorage.guide=false;//本次登录会话内不再提示
            req.post(window.context.portal +"/bpm/haiyaapi/updateManageGuide?account="+User.account).then((response) => {
              // window.app.$alert("您已跳过本次系统操作指引。", '提示');
            });
          }
      }).start();
  },
    closeHood(){
      $(".Hood").hide();
      let this_ = this;
      this_.Hood=false;
      this_.TimeOut=0;
      sessionStorage.HolidayTips=false;//不允许弹出节假日
      let User = JSON.parse(window.sessionStorage.currentUser);

      req.post(window.context.portal +"/bpm/haiyaapi/getManageGuide?account="+User.account).then((response) => {
        if(response.data.count>0 && (sessionStorage.guide=='true' || sessionStorage.guide==true)){//还有操作指引提示次数
          /* vue.js加载完成事件*/
          let timer = setInterval(function () {
            // 判断文档和所有子资源(图片、音视频等)已完成加载
            if (document.readyState === 'complete') {
                //执行方法
                this_.guide();
                window.clearInterval(timer)
            }
          }, 2000)
        }
    });
    },
    getTipMessageData() {
      this.tipLoading = true;
      this.$store
        .dispatch("menu/getPopups")
        .then(({ state, value }) => {
          if (!state) return (this.isShowTip = false);

          this.messageList = value || [];
        })
        .finally(() => {
          this.tipLoading = false;
        });
    },
    goToTargetPage(tipItem) {
      const baseUrl = window.context.front;
      const token = this.$store.state.login.currentUser.token;
      const url = `${tipItem.url}?token=${token}`;
      switch (tipItem.popupType) {
        case "tab":
          //this.$router.push(tipItem.url);
          this.routerChange(tipItem.url);
          break;
        case "new":
           let winObjEI = window.open(`${baseUrl}${url}`, "_blank");
           let isClose = 1;
           let loop = setInterval(function() {
            if (winObjEI.closed && isClose == 1) {
              isClose--;
              //这里写刷新代码
              window.location.reload();
              clearInterval(loop);
            }
          }, 1000);
          break;
        case "dialog":
          this.dialogWidth = tipItem.dialogWidth + "px";
          this.tipTitle = tipItem.subject;
          this.srcUrl = `${baseUrl}${url}`;
          this.dialogTipVisible = true;
          this.$refs.tipDialog.$el.firstChild.style.height =
            tipItem.dialogHeight + "px";
          // window.open(url, "_blank", `toolbar=no, width=${tipItem.dialogWidth}, height=${tipItem.dialogHeight},top=140,left=200`);
          break;
        default:
          break;
      }
    },
    routerChange(url){
      this.menus.forEach(item=>{
        if(url.startsWith("/")){
          url = url.substr(1);
        }
        let alias = url.split("/")[0];
        if(item.alias === alias){
          this.setCurrentMenu(item.alias);
        }
        this.$router.push({ path: url });
      })
    },
    setCurrentMenu(alias) {
      sessionStorage.menu_alias=alias;
      let that = this;
      for (let i = 0; i < that.menus.length; i++) {
        if (that.menus[i].alias === alias) {
          this.$store.dispatch("menu/getCurrentMenu", {
            alias: that.menus[i].alias,
            name: that.menus[i].name
          });
          break;
        }
      }
    },
    goToSupervisorDetail(item) {
      //跳转到督办页面
      let isChildren = this.addList("/flowcenter", this.$router.options.routes); //动态新增二级路由
      if(!isChildren){
        let alias_new = {
          path: "/flowcenter",
          name: "alias_flowcenter",
          component: (resolve) => require(["@/views/menuContent.vue"], resolve),
          children: [],
        };
        this.$router.options.routes.push(alias_new);
        this.addList("/flowcenter", this.$router.options.routes); //动态新增二级路由
      }
      this.$router.push("/flowcenter/template/preview/wfzdrw")
      // this.$router.push({
      //   path: `/flowcenter/template/preview/wfzdrw`,
      // });
    },
    handleClose() {
      this.dialogTipVisible = false;
    },
    hideTip() {
      this.isShowTip = false;
    },
    dialogMessage(item) {
      const me_ = this;
      let notify = this.$notify.info({
        title: item.subject,
        duration: 0,
        dangerouslyUseHTMLString: true,
        position: "bottom-right",
        message: item.content,
        onClose: function() {
          if (item.count == 1) {
            me_.$store.dispatch("form/deleteFormRemindDataById", item.id);
          }
        },
        onClick: function() {
          notify.close();
          let path =
            "/statement/template/form/" +
            item.opemType +
            "/get/true?id=" +
            item.opemId +
            "&startFlow=false";
          me_.$router.push(path);
        },
      });
      this.notifyList.push(notify);
    },
    getEnterpriseNotice() {
      this.$http
        .get("${portal}/enterpriseNotice/v1/getShowEnterpriseNotice")
        .then((resp) => {
          /*this.EnterpriseNotice = resp.data;*/
          this.$set(this, "EnterpriseNotices", resp.data);
          this.isNoticeShow = false;
          this.$nextTick(() => {
            this.isNoticeShow = true;
          });
        });
    },
    addList(path, list) {
      const that = this;
      let isAddPath = false;
      let isChildren = false;
      for (let i = 0; i < list.length; i++) {
        //判断当前点击菜单的路由别名是否存在 router.js 里面
        if (path == list[i].path) {
          //存在
          //动态注册路由
          let index = path.replace("/", "");
          let templatePreview_new = {
            path: "template/preview/:templateKey",
            name: "templatePreview_" + index,
            props: true,
            component: (resolve) =>
              require([
                "@/components/dataTemplate/templatePreview.vue",
              ], resolve),
          }; //数据报表
          let templateHref_new = {
            path: "href/template/:alias",
            name: "templateHref_" + index,
            props: true,
            component: (resolve) =>
              require(["@/components/dataTemplate/templateHref.vue"], resolve),
          }; //URL菜单
          let querySql_new = {
            path: "querySql/queryView/:sqlAlias/:alias",
            name: "querySql_" + index,
            props: true,
            component: (resolve) =>
              require(["@/components/querySql/querySqlContent.vue"], resolve),
          }; //自定义视图
          let template_new = {
            path: "template/form/:templateKey/:action",
            name: "template_" + index,
            props: true,
            component: (resolve) =>
              require(["@/components/dataTemplate/templateForm.vue"], resolve),
          }; //数据报表
          let templateSingle_new = {
            path: "template/form/:templateKey/:action/:single",
            name: "templateSingle_" + index,
            props: true,
            component: (resolve) =>
              require(["@/components/dataTemplate/templateForm.vue"], resolve),
          }; //数据报表
          let templateQuerys_new = {
            path: "template/preview/:templateKey/:single/:parameterqQuerys",
            name: "templateQuerys_" + index,
            props: true,
            component: (resolve) =>
              require([
                "@/components/dataTemplate/templatePreview.vue",
              ], resolve),
          }; //数据报表
          if (list[i].children) {
            //判断是否重复添加路由
            for (let j = 0; j < list[i].children.length; j++) {
              let children = list[i].children[j];
              if (children.name == templatePreview_new.name) {
                isAddPath = true; // true ： 重复路由
                break;
              }
            }

            if (!isAddPath) {
              list[i].children.push(templatePreview_new);
              list[i].children.push(templateHref_new);
              list[i].children.push(querySql_new);
              list[i].children.push(template_new);
              list[i].children.push(templateSingle_new);
              list[i].children.push(templateQuerys_new);
              that.$router.$addRoutes(list);
            }
            isChildren = true;
            break;
          }
        }
      }
      return isChildren;
    },
  },
  destroyed() {
    this.notifyList.forEach((item) => {
      item.close();
    });
  },
};
</script>


<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";



/deep/ .el-badge__content.is-dot{
  height: 6px !important;
  width: 6px !important;
}

/deep/ .tip__message-item{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #52535E !important;
  cursor:pointer;
  border-bottom: 1px solid #F0F2F5;
}


/deep/ .tip__message-title{
  display: flex;
  padding: 0px !important;
  font-family: PingFang SC-Semibold, PingFang SC !important;
  font-weight: 600 !important;
  color: #292B44 !important;
  font-size: 16px !important;
}
/deep/ .tip__message-ul{
    padding-left: 16px !important;
    padding-right: 16px !important;
    margin: 0px !important;
    font-size: 12px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #1890FF !important;
    .tip__message-item{
      margin:0px 0px 0px 0px !important;
      padding-left: 0px !important;
      padding-right: 0px !important;
      padding-top: 0px !important;
      padding-bottom: 0px !important;
      height: 32px;
      line-height: 32px;
    }
}


/deep/ .el-collapse-item__header{
  background: #EDF6FB !important;
}

/deep/.tip-dialog {
  // height: 90%;
  .iframe-wrap {
    height: 100%;
  }
  .el-dialog__header {
    padding: 3px 20px;
    .el-dialog__title {
      color: #000;
      font-size: 12px;
    }

    .el-dialog__headerbtn {
      top: 3px;
    }
  }
  .el-dialog__body {
    height: calc(100% - 40px);
    padding: 0 20px;
  }
}

/deep/ .el-card.is-always-shadow{
  -webkit-box-shadow: 0px 0px 0px 0px red;
  box-shadow: 0px 0px 0px 0px red;
  border: 0px !important;
}

/deep/ .home_container > main{
  overflow-y: auto !important;
}
.home_container {
  .tip__message {
    border-radius:8px;
    width: 400px;
    height: 300px;
    // border: 1px solid #d2d2d2;
    background: #fff;
    box-shadow: 0px 6px 15px 4px rgba(10,34,62,0.2);
    position: fixed;
    bottom: 24px;
    right: 24px;
    transition: 0.5s;
    .tip__message-topwrap {
      border-bottom: 1px solid #F0F2F5;
      padding: 8px;

      font-size: 12px !important;
      font-family: PingFang SC-Semibold, PingFang SC !important;
      font-weight: 600 !important;
      color: #292B44 !important;
      line-height: 32px !important;
      height: 32px !important;
      display: flex;
      justify-content: space-between;
    }
    &-title {
      padding: 6px 10px;
      margin: 0;
    }
    .icon__wrap {
      &:hover {
        color: $--theme-color;
        cursor: pointer;
      }
      .icon__wrap-item {
        padding: 0px 18px 0px 0px;
        font-size: 14px;
      }
    }
    ul {
      list-style: none;
      padding-left: 5px;
      margin: 0 5px;
      .tip__message-item {
        // border: 1px dashed #40A9FF;
        &:hover {
          background: #EDF6FB;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
          // border: 1px solid #1890FF;
        }
      }
    }
  }
  .only__title {
    height: 48px;
    transition: 0.5s;
  }
}

/deep/ .el-col {
  padding: 16px 0px 0px 16px !important;
}

/deep/ .zq{
  .el-col{
    padding: 0px !important;
  }
}



/deep/ .el-main {
  padding: 0px 16px 16px 0px !important;
  background: #F0F2F5;
}
/deep/.el-main,
/deep/.column-body {
  // 隐藏滚动条
  &::-webkit-scrollbar {
    width: 0;
    background-color: transparent;
  }
  /*火狐下隐藏滚动条*/
  scrollbar-width: none;
}
@media (min-width: 1280px) and (max-width: 1366px) {
  /deep/.left_title {
    font-size: 17px !important;
  }
}
@media (max-width: 1152px) {
  /deep/ .img_wrap,
  /deep/.img_wrap > img {
    width: 46px !important;
    height: 46px !important;
  }
  /deep/.left_title {
    font-size: 13px !important;
  }
  /deep/.left_text {
    line-height: 16px !important;
  }
  /deep/.flow_item {
    padding: 0 6px !important;
    .flow_item__bg {
      width: 32px !important;
      height: 32px !important;
      margin-top: 4px;
      span {
        font-size: 22px !important;
        padding: 6px !important;
      }
    }
    .flow_item__count {
      font-size: 14px !important;
      line-height: 26px !important;
    }
    .flow_item__text {
      zoom: 0.9;
      line-height: 26px !important;
    }
  }
}
.supervisor-wrap__title {
  margin: 3px 0;
  padding-left: 10px;
}

/deep/ .Hood{
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1001;
    justify-content:center; 
		align-items:center;
		display:flex; 
}

/deep/ .carouselIndex{
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 1001;
      justify-content:center; 
      align-items:center;
      display:flex; 
}

// /deep/ .HoodBackground{
//   text-align: center;
// }


  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    margin: 0;
  }
  
  // .el-carousel__item:nth-child(2n) {
  //   background-color: #99a9bf;
  // }
  
  // .el-carousel__item:nth-child(2n+1) {
  //   background-color: #d3dce6;
  // }
  /deep/ .haiyaText{
    color: #ffffff;font-size: 16px;font-family: Source Han Sans CN;font-weight: 400;
    p{
      color: #ffffff;font-size: 16px;font-family: Source Han Sans CN;font-weight: 400;
    }
  }

</style>
